import { render, staticRenderFns } from "./NewsTags.vue?vue&type=template&id=202f58b1&scoped=true"
import script from "./NewsTags.vue?vue&type=script&lang=js"
export * from "./NewsTags.vue?vue&type=script&lang=js"
import style0 from "./NewsTags.vue?vue&type=style&index=0&id=202f58b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f58b1",
  null
  
)

export default component.exports